// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3961":"d96d7599","4359":"d96d7599","8810":"d96d7599"}[chunkId] + ".chunk.css";
};